import axios, { AxiosError, AxiosInstance, AxiosRequestConfig } from 'axios';
import { toast } from 'react-toastify';
import authActions from '../store/auth/authAction';
import store from '../store/store';

const config: AxiosRequestConfig = {
  baseURL: process.env.REACT_APP_API_END_POINT
};

export const isHttpError = (error: any): error is AxiosError => axios.isAxiosError(error);

export type HttpError = AxiosError;

export interface ConstraintError {
  propertyPath: string;
  message: string;
  code: string;
}

export type ConstraintsError = ConstraintError[];

export interface ServerError {
  errorMessage: string;
}

export const http: AxiosInstance = axios.create(config);

let { token: jwt } = store.getState().auth;

store.subscribe(() => {
  jwt = store.getState().auth.token;
});

http.interceptors.request.use((config) => {
  if (jwt) {
    config.headers = {
      Authorization: `Bearer ${jwt}`,
      Accept: '*',
      'Content-Type': 'application/json'
    };
  }

  return config;
});

/**
 * Expired JWT
 */

http.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response.status === 401 && error.response?.data?.message === 'Expired JWT Token') {
      console.error('Expired token');
      store.dispatch(authActions.logout());
      toast.error('Please login below to connect.');
    } else {
      return Promise.reject(error);
    }
  }
);

export const isContraintError = (error: any): boolean =>
  error.hasOwnProperty('propertyPath') ? true : false;
